module.exports = __webpack_public_path__ + "static/media/71-vMzevFhL._AC_UX466_.876851ec.jpg";